import React, {forwardRef, useRef} from 'react';

import {LoadTrigger} from '../../LoadTrigger';

export type CustomListboxProps = {
  hasMoreBefore?: boolean;
  hasMoreAfter?: boolean;
  onLoadMoreBefore?: () => Promise<void>;
  onLoadMoreAfter?: () => Promise<void>;
};

export const ListboxComponent = forwardRef(
  (
    props: React.HTMLAttributes<HTMLElement> & CustomListboxProps,
    ref: React.ForwardedRef<HTMLDivElement>
  ) => {
    const listRef = useRef<HTMLUListElement>(null);
    const {
      children,
      hasMoreBefore,
      hasMoreAfter,
      onLoadMoreBefore,
      onLoadMoreAfter,
      ...other
    } = props;

    // changing value on each re-render needed for reload detection in LoadTrigger
    const count = useRef(0);
    count.current += 1;

    return (
      <div ref={ref}>
        <ul ref={listRef} {...other}>
          {hasMoreBefore !== undefined && onLoadMoreBefore && (
            <LoadTrigger
              dataSize={count.current}
              hasMore={hasMoreBefore}
              listRef={listRef}
              isTop
              onLoad={onLoadMoreBefore}
            />
          )}
          {children}
          {hasMoreAfter !== undefined && onLoadMoreAfter && (
            <LoadTrigger
              dataSize={count.current}
              hasMore={hasMoreAfter}
              listRef={listRef}
              onLoad={onLoadMoreAfter}
            />
          )}
        </ul>
      </div>
    );
  }
);
